import * as React from "react";
import { FieldError } from "../ErrorMessage";
import * as cn from "classnames";
import { SvgIcon } from "../SvgIcon";
import { Funnel2, Triangle } from "@icons";
import { campaignMediaPlanForm, KPIMapping } from "@store";
import { PremiumFeatureIcon } from "../PremiumFeatureIcon";
import { Fieldset } from "../Fieldset";

export interface PricingModelComponentProps {
    value: string | null;
    onChange: (newValue: string | null) => void;
    field: any | null;
    events: typeof campaignMediaPlanForm.types.eventBindings;
    handleClearAllCheckBoxes: () => void;
    onSetPriceModel: (priceModel: string) => void;
    onSetPrimaryKPI: (primaryKPI: string) => void;
    // Other props here
    kpiMapping: KPIMapping[];
    primaryKPIValue: string | null;
    primaryKPIOnChange: (newValue: string | null) => void;
    primaryKPIField: any | null;
    secondaryKPIValue: string | null;
    secondaryKPIOnChange: (newValue: string | null) => void;
    secondaryKPIField: any | null;
}

const options = [
    {
        name: "Impressions and Reach",
        unit: "CPM"
    },
    {
        name: "Views",
        unit: "vCPM",
        status: "trial"
    },
    { name: "Clicks", unit: "CPC" },
    { name: "Landings", unit: "CPL", status: "lock" },
    { name: "Sessions", unit: "CPS", status: "lock" }
];

function choseSvg(value: string) {
    let svgClass;
    switch (value) {
        case "CPM":
            svgClass = "active-CPM";
            break;
        case "vCPM":
            svgClass = "active-vCPM";
            break;
        case "CPC":
            svgClass = "active-CPC";
            break;
        default:
            return null;
    }

    return <SvgIcon svg={Funnel2} className={cn("funnel-svg", svgClass)} />;
}

export class PricingModelComponent extends React.Component<PricingModelComponentProps, any> {
    constructor(props: PricingModelComponentProps) {
        super(props);
    }

    handleOnChangeCPC(value: string) {
        const { onSetPriceModel } = this.props;

        onSetPriceModel(value);
    }

    handleOnChangePrimaryKPI(value: string) {
        const { onSetPrimaryKPI } = this.props;
        onSetPrimaryKPI(value);
    }

    render() {
        const {
            value,
            field,
            kpiMapping,
            primaryKPIValue,
            primaryKPIField,
            secondaryKPIValue,
            secondaryKPIOnChange,
            secondaryKPIField
        } = this.props;

        const primaryOptions = kpiMapping && kpiMapping.filter(kpi => (kpi.type === "primary" ? true : false));
        const secondaryMass =
            kpiMapping && primaryKPIValue && kpiMapping.find(kpi => kpi.name === primaryKPIValue).secondary;
        const secondaryOptions = secondaryMass && secondaryMass.map(s => kpiMapping.find(k => k.name === s));

        return (
            <div className={cn("radio-wrapper", field.visualState)}>
                <div className="pricing-inner-wrapper">
                    <div className="pricing-select-wrapper">
                        <Fieldset
                            label="Primary"
                            errorMessage={primaryKPIField}
                            isMandatory={true}
                            icon={Triangle}
                            svgClassName="svg-triangle"
                        >
                            <select
                                className="common-select"
                                name="primary"
                                id=""
                                value={primaryKPIValue || ""}
                                onChange={e => this.handleOnChangePrimaryKPI(e.currentTarget.value)}
                            >
                                {kpiMapping &&
                                    primaryOptions.map((kpi, index) => (
                                        <option key={index} value={kpi.name}>
                                            {kpi.display}
                                        </option>
                                    ))}
                            </select>
                        </Fieldset>
                        <Fieldset
                            label="Secondary"
                            errorMessage={secondaryKPIField}
                            isMandatory={false}
                            icon={Triangle}
                            svgClassName="svg-triangle"
                            className={cn(
                                "Fieldset__no-margin-r",
                                secondaryOptions && secondaryOptions.length > 0 ? "" : "Fieldset_disabled"
                            )}
                        >
                            <select
                                className="common-select"
                                name="secondary"
                                id=""
                                value={secondaryKPIValue || ""}
                                onChange={e => secondaryKPIOnChange(e.currentTarget.value)}
                                disabled={secondaryOptions && secondaryOptions.length > 0 ? false : true}
                            >
                                <option value="">None</option>
                                {secondaryOptions &&
                                    secondaryOptions.map((s, index) => (
                                        <option key={index} value={s.name}>
                                            {s.display}
                                        </option>
                                    ))}
                            </select>
                        </Fieldset>
                    </div>
                    {choseSvg(value)}
                    <ul className="price-model-list">
                        {options.map((option, index) => (
                            <li
                                key={index}
                                className={option.unit === "CPL" || option.unit === "CPS" ? "disabled" : ""}
                                onClick={() =>
                                    option.unit === "CPL" || option.unit === "CPS"
                                        ? ""
                                        : this.handleOnChangeCPC(option.unit)
                                }
                            >
                                <div className="pricing-premium-block-wrapper">
                                    <label className="common-radio custom-pricing-radio">
                                        <input
                                            type="radio"
                                            name="campaign-goal"
                                            value={option.unit}
                                            id=""
                                            checked={value === option.unit}
                                            onChange={() => this.handleOnChangeCPC(option.unit)}
                                            disabled={option.unit === "CPL" || option.unit === "CPS" ? true : false}
                                        />
                                        <span className="checkmark" />
                                    </label>
                                    {option.status && (
                                        <PremiumFeatureIcon
                                            className="custom-pricing-premium-icon"
                                            status={option.status as "trial" | "lock"}
                                        />
                                    )}
                                </div>
                                <div className="text-wrapper">
                                    <span>{option.name}</span>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
                <FieldError field={field} />
            </div>
        );
    }
}
